/* eslint-disable no-param-reassign */
import * as types from '../types';

const app = {
  state: {
    isLoading: false,
    fwlbbzList: [],
    macro: [
      { key: 'ZJLX', name: 'ZRR_SFZ', value: '51', label: '公民身份号码' },
      { key: 'ZJLX', name: 'ZRR_JGZ', value: '41', label: '军官证编号' },
      { key: 'FWLBBZ', name: 'GD', value: '2', label: '电' },
      { key: 'FWLBBZ', name: 'GS', value: '1', label: '冷水' },
      { key: 'FWLBBZ', name: 'RS', value: '6', label: '热水' },
      { key: 'FWLBBZ', name: 'GQ', value: '3', label: '燃气' },
      { key: 'FWLBBZ', name: 'GN', value: '4', label: '暖气' },
      { key: 'FWLBBZ', name: 'WY', value: '5', label: '物业' },
      { key: 'FWLBBZ', name: 'FWZL', value: '7', label: '房屋租赁' },
      { key: 'FWLBBZ', name: 'LJQY', value: '8', label: '垃圾费代收' },
      { key: 'SFBZ', name: 'NO', value: '1', label: '否' },
      { key: 'SFBZ', name: 'YES', value: '2', label: '是' },
      { key: 'LSYNBZ', name: 'ZC', value: '1', label: '正常' },
      { key: 'LSYNBZ', name: 'LS', value: '2', label: '临时' },
      { key: 'FKPJFBZ', name: 'BZX', value: '1', label: '不执行丰枯' },
      { key: 'FKPJFBZ', name: 'ZXFKP', value: '2', label: '执行丰枯' },
      { key: 'YBWBBZ', name: 'YB', value: '1', label: '有表' },
      { key: 'YBWBBZ', name: 'WB', value: '2', label: '无表' },
      { key: 'JTLXBZ', name: 'NJT', value: '1', label: '年' },
      { key: 'JTLXBZ', name: 'YJT', value: '2', label: '月' },
      { key: 'FSJFBZ', name: 'FS2FS', value: '1', label: '2分时' },
      { key: 'FSJFBZ', name: 'FS3FS', value: '2', label: '3分时' },
      { key: 'FSJFBZ', name: 'FS4FS', value: '3', label: '4分时' },
      { key: 'TGKZBZ', name: 'ZC', value: '1', label: '正常' },
      { key: 'TGKZBZ', name: 'TGKZ', value: '2', label: '停供/空置' },
      { key: 'LJJFFSBZ', name: 'JM', value: '1', label: '按人口' },
      { key: 'LJJFFSBZ', name: 'SY', value: '2', label: '按面积' },
      { key: 'ZCZBBZ', name: 'ZQXZCJF', value: '1', label: '周期性正常计费' },
      { key: 'ZCZBBZ', name: 'ZQXYHJF', value: '2', label: '周期性优惠计费' },
      { key: 'ZCZBBZ', name: 'YW_GH', value: '-1', label: '过户' },
      { key: 'ZCZBBZ', name: 'YW_BGJF', value: '-2', label: '变更' },
      { key: 'ZCZBBZ', name: 'YW_XH', value: '-3', label: '销户' },
      { key: 'ZCZBBZ', name: 'YW_TSZB', value: '-4', label: '特殊追补' },
      { key: 'ZCZBBZ', name: 'YW_ZBF', value: '-5', label: '非周期结费' },
      { key: 'ZFQDBZ', name: 'YEZF', value: '1', label: '余额支付' },
      { key: 'ZFQDBZ', name: 'WXZF', value: '2', label: '微信支付' },
      { key: 'ZFQDBZ', name: 'ZFBZF', value: '3', label: '支付宝支付' },
      { key: 'ZFQDBZ', name: 'JHLZF', value: '4', label: '建行龙支付' },
      { key: 'CBZTBZ', name: 'WC', value: '1', label: '未抄' },
      { key: 'CBZTBZ', name: 'ZZCB', value: '2', label: '已抄' },
      { key: 'CBZTBZ', name: 'YCZC', value: '3', label: '已抄正常' },
      { key: 'CBZTBZ', name: 'YCYC', value: '4', label: '已抄异常' },
      { key: 'CBZTBZ', name: 'ZZHS', value: '5', label: '正在核算' },
      { key: 'NLLXBZ', name: 'ZX', value: '1', label: '正向' },
      { key: 'NLLXBZ', name: 'FX', value: '2', label: '反向' },
      { key: 'SSLXBZ', name: 'C', value: '1', label: '常' },
      { key: 'SSLXBZ', name: 'JF', value: '2', label: '尖峰' },
      { key: 'SSLXBZ', name: 'F', value: '3', label: '峰' },
      { key: 'SSLXBZ', name: 'P', value: '4', label: '平' },
      { key: 'SSLXBZ', name: 'G', value: '5', label: '谷' },
      { key: 'SSLXBZ', name: 'DG', value: '6', label: '低谷' },
      { key: 'SSLXBZ', name: 'WG', value: '7', label: '无功' },
      { key: 'SSLXBZ', name: 'XL', value: '8', label: '需量' },
      { key: 'SSLXBZ', name: 'YDJ', value: '98', label: '月冻结' },
      { key: 'SSLXBZ', name: 'NDJ', value: '99', label: '年冻结' },
      { key: 'ICKZTBZ', name: 'WPK', value: '1', label: '未配卡' },
      { key: 'ICKZTBZ', name: 'YPK', value: '2', label: '已配卡' },
      { key: 'EWMLXBZ', name: 'LZF', value: '1', label: '龙支付' },
      { key: 'EWMLXBZ', name: 'WX', value: '2', label: '微信' },
      { key: 'EWMLXBZ', name: 'ZFB', value: '3', label: '支付宝' },
      { key: 'EWMLXBZ', name: 'YL', value: '4', label: '银联' },
      { key: 'JSWZBZ', name: 'BB_WCB', value: '1', label: '本表-未抄表' },
      { key: 'JSWZBZ', name: 'BB_ZZCB', value: '2', label: '本表-正在抄表' },
      { key: 'JSWZBZ', name: 'BB_YCYC', value: '3', label: '本表-已抄异常' },
      { key: 'JSWZBZ', name: 'BB_ZZCSH', value: '8', label: '正在初始化' },
      { key: 'JSWZBZ', name: 'BB_CBWB', value: '10', label: '本表-抄表完毕' },
      { key: 'JSWZBZ', name: 'TJ_WMZB', value: '11', label: '套减-本表无母子表' },
      { key: 'JSWZBZ', name: 'TJ_MBWJ', value: '12', label: '套减-目标未减' },
      { key: 'JSWZBZ', name: 'TJ_ZBWFJ', value: '13', label: '套减-子表无法减' },
      { key: 'JSWZBZ', name: 'TJ_MZBJWJ', value: '14', label: '套减-母子表均未减' },
      { key: 'JSWZBZ', name: 'TJ_TJYC', value: '15', label: '套减-套减异常' },
      { key: 'JSWZBZ', name: 'TJ_TJWB', value: '20', label: '套减-套减完毕' },
      { key: 'JSWZBZ', name: 'JF_ZZJF', value: '21', label: '计费-正在计费' },
      { key: 'JSWZBZ', name: 'JF_SCCZSJ', value: '22', label: '计费-生成出账数据' },
      { key: 'JSWZBZ', name: 'JF_CZSJYC', value: '23', label: '计费-出账数据异常' },
      { key: 'JSWZBZ', name: 'JF_JFWB', value: '30', label: '计费-计费完毕' },
      { key: 'JSWZBZ', name: 'CZ_YSCZ', value: '31', label: '出账-应收出账' },
      { key: 'JSWZBZ', name: 'CZ_ZDXZ', value: '32', label: '出账-自动销账' },
      { key: 'JSWZBZ', name: 'CZ_CSHHSSJ', value: '33', label: '出账-初始化核算数据' },
      { key: 'JSWZBZ', name: 'CZ_GXGSDA', value: '34', label: '出账-更新核算档案' },
      { key: 'JSWZBZ', name: 'CZ_CZWB', value: '9999', label: '出账-出账完毕' },
      { key: 'CBQDBZ', name: 'CBYC', value: '1', label: '抄表员抄' },
      { key: 'CBQDBZ', name: 'YHZC', value: '2', label: '客户抄' },
      { key: 'CBQDBZ', name: 'ZDCB', value: '3', label: '第三方抄' },
      { key: 'XJZZBZ', name: 'XJ', value: '1', label: '现金' },
      { key: 'XJZZBZ', name: 'XJZP', value: '2', label: '银行存款' },
      { key: 'XJZZBZ', name: 'ZZZP', value: '3', label: '转账支票' },
      { key: 'XJZZBZ', name: 'HP', value: '4', label: '汇票' },
      { key: 'XJZZBZ', name: 'CDHP', value: '5', label: '承兑汇票' },
      { key: 'XJZZBZ', name: 'DSFZF', value: '6', label: '第三方支付' },
      { key: 'XJZZBZ', name: 'YS', value: '-1', label: '应收' },
    ],
  },
  getters: {
    isLoading: state => state.isLoading,
    fwlbbzList: state => state.fwlbbzList,
    Macro: (state) => {
      const obj = {};
      state.macro.forEach((m) => {
        if (!obj[m.key]) {
          obj[m.key] = {};
        }
        obj[m.key][m.name] = { label: m.label, value: m.value };
      });
      return obj;
    },
    getMacroList: state => (key) => {
      const arr = [];
      state.macro.forEach((e) => {
        if (e.key === key) {
          arr.push(e);
        }
      });
      return arr;
    },
    getMacroDes: state => (key, val) => {
      if (!val) return '';
      const m = state.macro.find(e =>
        (e.key === key && e.value === val.toString()));
      if (m) {
        return m.label;
      }
      return '';
    },
  },
  mutations: {
    [types.APP_UPDATE_LOAING_STATUS]: (state, payload) => {
      state.isLoading = payload.isLoading;
    },
    [types.APP_FWLBBZ_LIST]: (state, data) => {
      state.fwlbbzList = data;
    },
  },
  actions: {},
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js